define.alias("ember-cli-string-helpers/utils/titleize", "calendar/utils/titleize");